<template>
  <component
    :is="htmlTag"
    :class="['c-button', size, className, { outline }]"
    :style="styleColor"
    :type="type"
    :disabled="disabled"
    @click="onClick"
    v-bind="attribute"
  >
    <slot></slot>
  </component>
</template>

<script>
const REGEX_HEX = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/

export default {
  name: 'ComponentButton',
  props: {
    hexBackground: {
      type: String,
      default: undefined,
      validator: (value) => {
        return !value || REGEX_HEX.test(value)
      },
    },
    hexText: { type: String, default: undefined },
    preventDefault: { type: Boolean, default: false },
    attribute: {
      type: Object,
      default: () => {
        return {}
      },
    },
    className: { type: String, default: '' },
    disabled: { type: Boolean, default: undefined },
    htmlTag: { type: String, default: 'a' },
    outline: { type: Boolean, default: false },
    hex: {
      type: String,
      default: '',
      validator: (value) => {
        return !value || REGEX_HEX.test(value)
      },
    },
    size: { type: String, default: '' },
    type: { type: String, default: '' },
  },
  computed: {
    styleColor() {
      if (this.hexBackground && !this.disabled) {
        return {
          backgroundColor: this.hexBackground,
          borderColor: this.hexBackground,
        }
      }
      return this.outline
        ? { borderColor: this.hex, color: this.hexText || this.hex }
        : { backgroundColor: this.hex, borderColor: this.hex }
    },
  },
  methods: {
    onClick($event) {
      this.preventDefault ? $event.preventDefault() : $event.stopPropagation()
      if (!this.disabled) this.$emit('button-clicked', $event)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/modules/button';

.c-button {
  @extend .m-button;
}
</style>
